import { defineStore } from 'pinia'
import authService from '@/services/auth'
import userService from '@/services/user'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    userData: {firstName: null, lastName: null, email: null, id: null, permissions: []},
    token: localStorage.getItem('token') || null,
    dataFetched: false,
    loadingData: false,
    originalRoute: null
  }),
  
  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.userData,
    isDataFetched: (state) => state.dataFetched,
    isLoadingData: (state) => state.loadingData,
    getOriginalRoute: (state) => state.originalRoute
  },
  
  actions: {

    updateOriginalRoute(route) {
      this.originalRoute = route;
    },

    async changeDataFetched(value) {
      this.dataFetched = value;
    },

    async changeLoadingData(value) {
      this.loadingData = value;
    },

    async isUserAuthenticated() {
      try {
        await authService.isUserAuthenticated()
        return true
      } catch (error) {
        console.log("error", error);
        return false
      }
    },

    async login(credentials) {
      const response = await authService.login(credentials)
      return response
    },

    async forgotPassword(email) {
      const response = await authService.forgotPassword(email)
      return response
    },

    async resetPassword(token, newPassword) {
      const response = await authService.resetPassword(token, newPassword)
      return response
    },

    async getUserData() {
      const response = await userService.getUserData()
      const userResponse = response?.user;
      if ( !userResponse?.firstName || !userResponse?.lastName || !userResponse?.email || !userResponse?.id || !userResponse?.permissions) {
        throw new Error('Error al obtener los datos del usuario');
      }
      this.userData.firstName = userResponse.firstName || '';
      this.userData.lastName = userResponse.lastName || '';
      this.userData.email = userResponse.email || '';
      this.userData.id = userResponse.id || null;
      this.userData.permissions = userResponse.permissions || [];
      return userResponse;
    }
  }
}) 